import { render, staticRenderFns } from "./fxWorke.vue?vue&type=template&id=c4b8def2&scoped=true&"
import script from "./fxWorke.vue?vue&type=script&lang=js&"
export * from "./fxWorke.vue?vue&type=script&lang=js&"
import style0 from "./fxWorke.vue?vue&type=style&index=0&id=c4b8def2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b8def2",
  null
  
)

export default component.exports